import * as React from "react";
import { handleMagicLink } from "../services/MagicLinkService";
import { tokenExchange as handleFicoMagicLink } from "../services/tokenExchange";
import { extractAccessToken, containsScope } from "../services/TokenService";
import { parseReturnToQueryParam } from "../utils/utils";
import { Spinner } from "./Spinner";

interface IProps {
  location: Location;
}

export class MagicLinkHandler extends React.Component<IProps, {}> {
  componentDidMount() {
    const accessToken = extractAccessToken(this.props.location.search);
    const returnToParam = parseReturnToQueryParam(this.props.location.search);
    containsScope(accessToken, "all")
      ? handleFicoMagicLink(accessToken, returnToParam)
      : handleMagicLink(accessToken, returnToParam);
  }

  render() {
    return <Spinner />;
  }
}
